import orderCenterApi from '@/request/orderCenter/index.js'

const actions = {
  udpateSettlementSearchByAction({ commit }, data) {
    commit('udpateSettlementSearchByMutation', data)
  },
  updateSettlementDetailsSearch({ commit }, data) {
    commit('updateSettlementDetailsSearch', data)
  },
  updateTrueTally({ commit }, data) {
    commit('updateTrueTally', data)
  },

  udpateNodeEnum({ commit }, data) {
    commit('udpateNodeEnum', data)
  },

  udpateAudit({ commit }, data) {
    commit('udpateAudit', data)
  },

  getProcessConfiguration({ commit }, eduId) {
    orderCenterApi.getProcessConfiguration({ eduId }).then(res => {
      if (res.data.status == 200) {
        commit('updateProcessConfiguration', res.data.message)
      }
    })
  }
}

export default actions
